<ion-grid [ngClass]="(!!navService.isActiveChildNavRightPaneViewDisplayed)?'preview-active':'preview-inactive'">
  <ion-row>
    <ion-col class="kol-status-page-left-pane omni-left-pane">
      <kol-status-list></kol-status-list>
    </ion-col>
    <ion-col class="kol-status-page-right-pane omni-right-pane">
      <ion-nav #kolstatuspagerightpane></ion-nav>
    </ion-col>
  </ion-row>
</ion-grid>